import { render, staticRenderFns } from "./MedicalForm.vue?vue&type=template&id=59fbfb6f&scoped=true&"
import script from "./MedicalForm.vue?vue&type=script&lang=js&"
export * from "./MedicalForm.vue?vue&type=script&lang=js&"
import style0 from "./MedicalForm.vue?vue&type=style&index=0&id=59fbfb6f&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fbfb6f",
  null
  
)

export default component.exports